// Module
var code = "<react-component name=\"ConfirmBulkSuspendContacts\"></react-component>\n";
// Exports
module.exports = code;